import React from "react"
import Cabecalho from "../Cabecalho"
import { Loading } from "../RegistradorDePedidos"
import { IntegracaoPickngoForm } from "./components/IntegracaoPickngoForm"

export function Index() {
    return (
        <>
            <Cabecalho pagina="Integração Pick'n Go" />
            <Loading />
            <IntegracaoPickngoForm />
        </>
    )
}
